import classNames from 'classnames'
import { FC } from 'react'

interface Props {
  id: string
  images: string[]
  defaultImage?: string
  onImageClick?: (image: string) => void
}

const Carousel: FC<Props> = ({ images, onImageClick, id, defaultImage }) => {
  const handleImageClick = (image: string) => () => onImageClick?.(image)
  const isImageActive = (image: string, index: number) => {
    if (defaultImage) {
      return image === defaultImage
    } else {
      return index === 0
    }
  }

  return (
    <div
      id={id}
      className='carousel carousel-fade transition-none slide relative flex justify-center items-center bg-black px-14'
      data-bs-ride='carousel'
      data-bs-interval='false'
      data-bs-pause='hover'
    >
      <div className='carousel-inner relative w-full overflow-hidden transition-none'>
        {images.map((image, index) => (
          <div className={classNames('carousel-item relative float-left w-full', isImageActive(image, index) ? 'active' : '')} key={image}>
            <img
              onClick={handleImageClick(image)}
              src={require(`assets/images/${image}`)}
              className='block w-full rounded-md cursor-pointer hover:opacity-90 pointer-events-none md:pointer-events-auto'
              alt='Wild Landscape'
            />
          </div>
        ))}
      </div>

      <button
        type='button'
        className='carousel-control-prev absolute top-0 left-0 z-30 items-center justify-center h-full px-4 cursor-pointer group focus:outline-none'
        data-bs-target={`#${id}`}
        data-bs-slide='prev'
      >
        <span className='inline-flex flex-none items-center justify-center w-8 h-8 rounded-full bg-white/50 group-hover:bg-white/70 group-focus:outline-none'>
          <svg
            aria-hidden='true'
            className='w-5 h-5 text-white'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M15 19l-7-7 7-7'></path>
          </svg>
          <span className='sr-only'>Previous</span>
        </span>
      </button>
      <button
        type='button'
        className='carousel-control-next absolute top-0 right-0 z-30 flex items-center justify-center h-full px-4 cursor-pointer group focus:outline-none'
        data-bs-target={`#${id}`}
        data-bs-slide='next'
      >
        <span className='inline-flex flex-none items-center justify-center w-8 h-8 rounded-full bg-white/50 group-hover:bg-white/70 group-focus:outline-none'>
          <svg
            aria-hidden='true'
            className='w-5 h-5 text-white'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path strokeLinecap='round' strokeLinejoin='round' strokeWidth='2' d='M9 5l7 7-7 7'></path>
          </svg>
          <span className='sr-only'>Next</span>
        </span>
      </button>
    </div>
  )
}

export default Carousel
